<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('home.welcome') }}</h1>
    </layout-authenticated>
</template>

<script>
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Home',
    components: {LayoutAuthenticated},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/',
                    disabled: true
                }
            ];
        }
    }
}
</script>
